/**
 * 在途监管平台 — 登录守卫
 * 未登录（localStorage 无 token）访问受保护路由 → 重定向 /login?redirect={原路径}
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { TOKEN_KEY } from '@/api/http';

export default function AuthGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const token = localStorage.getItem(TOKEN_KEY);

  if (!token) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  return <>{children}</>;
}
